import { memo, useCallback } from "react";
import { CardSelect } from "ui/components/CardSelect";
import { ENTITY_TYPE_CARD_OPTIONS } from "services/api/notifications/consts";
import { EntityTypeSelectorProps } from "./types";

const EntityTypeSelector: React.FC<EntityTypeSelectorProps> = ({
  selectedType,
  error,
  onChange,
}) => {
  // CardSelect barata string id-jevima; tip entiteta je enum broj, pa se vraća natrag.
  const handleChange = useCallback((id: string) => onChange(Number(id)), [onChange]);

  return (
    <div className="flex-1">
      <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">
        Kreiranje nove notifikacije
      </h1>
      <p className="text-center text-sm text-slate-600 mb-6 max-w-2xl mx-auto ">
        Odaberite grupu za koju želite primati notifikacije
      </p>

      <CardSelect
        options={ENTITY_TYPE_CARD_OPTIONS}
        value={selectedType != null ? String(selectedType) : null}
        onChange={handleChange}
        columns={1}
        error={error}
      />
    </div>
  );
};

export default memo(EntityTypeSelector);
